import React from 'react';
// Import Image component for the logo
import { Navbar, Nav, Image } from 'react-bootstrap'; 
import { LinkContainer } from 'react-router-bootstrap'; // To integrate react-router with react-bootstrap

const Header = () => {
  return (
    <Navbar style={{ backgroundColor: 'rgba(0, 0, 0, 1)' }} variant="dark" expand="lg" sticky="top">
      {/* The Navbar.Brand now contains both the Image (logo) and the company name.
        **ACTION REQUIRED:** Place your logo file (e.g., 'business_logo.png') 
        in your 'frontend/public/images/' folder.
      */}
      <Navbar.Brand href="/">
        <Image 
          // Use the static public path since the image is in public/images/
          src="/images/business_logo.png" 
          alt="FRIEND’S-TECH CORPORATION Logo"
          // Adjust the height as necessary. marginRight adds spacing next to the name.
          style={{ height: '30px', marginRight: '10px' }} 
        />
       Friends-Tech Corporation
      </Navbar.Brand>
      
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto"> {/* ml-auto pushes items to the right */}
          <LinkContainer to="/"><Nav.Link>Home</Nav.Link></LinkContainer>
          <LinkContainer to="/products"><Nav.Link>Products</Nav.Link></LinkContainer>
          <LinkContainer to="/profile"><Nav.Link>Company Profile</Nav.Link></LinkContainer>
          {/*<LinkContainer to="/industries"><Nav.Link>Industries</Nav.Link></LinkContainer>*/}
          <LinkContainer to="/about"><Nav.Link>About Us</Nav.Link></LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;